import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import Jobseekersignup from "./Jobseekersignup";
import Employersignup from "./Employersignup";
import ForgienStudyProvider from "./ForgienStudyProvider";
// import { ToastContainer, toast } from "react-toastify";
import {
  user_verify,
  Resendotp,
  resetUserVerification,
  get_selected_User_District,
  set_RegisterUser,
  setRedirectionLink,
  get_User_Type,
  getConstituency,
  getSectors,
  getCourses,
  sendOtp,
  set_Loader,
  unset_Loader,
} from "../../actions/accountAction";
import store from "../../store";
import { Link } from "react-router";
import Validation from "../hoc/Validation";
import ForgienProvider from "./ForgienProvider";
import axios from "axios";
import ServerSetting from "../../config.json";
import { setNotification } from "../../actions/notificationAction";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import StarRatings from "react-star-ratings";
import { LoadCanvasTemplate, LoadCanvasTemplateNoReload, loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha";

const RESULT_PER_PAGE = 25;
let environment =
  typeof process.env.NODE_ENV !== "undefined" &&
    process.env.NODE_ENV === "production"
    ? "production"
    : "development";
let API_SERVER = ServerSetting[environment].API_SERVER;

class feedbackForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitStatus: false,
      basePath: window.location.protocol + "//" + window.location.host + "/",

      formData: {
        full_name: "",
        mobile: "",
        email_id: "",
        feedback_type: "CAT_FEEDBACK",
        message: "",
        rating: 0,
        otp: "",

      },
      errors: {},
      loading: false,
      querydata: [], //
      is_otp_verify: 0,
      district_id: '',
      sector_id: '',
      course_id: '',
      isCaptchaVerified: false,
      constituency_id: ''
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    store.dispatch(get_selected_User_District());
    store.dispatch(get_User_Type());
    store.dispatch(getConstituency());
    store.dispatch(getSectors())
    if (this.props.location.query.action) {
      store.dispatch(setRedirectionLink(this.props.location.query.action));
    }
  }

  componentDidMount() {
    document.title = this.props.t("Feedback and Technical Query", { param: "react" });
    this.fetchquerytypeData();
    // loadCaptchaEnginge(6);
  }


  componentWillUnmount() {
    store.dispatch(resetUserVerification());
    store.dispatch(set_RegisterUser([]));
  }

  handleSubmit(event) {
    event.preventDefault();
    const user = {
      otp: this.state.opt,
      username: this.props.actionReducer.Registeruser.username,
    };
    if (!this.state.submitStatus && this.props.validator.allValid()) {
      this.setState({ submitStatus: true });
      store.dispatch(user_verify(user));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else {
      this.props.validator.showMessages();
      this.forceUpdate();
    }
  }
  handleUserSentotp(event) {
    event.preventDefault();
    const user = {
      mobile: this.props.actionReducer.Registeruser.mobile,
    };
    store.dispatch(Resendotp(user));
  }

  changeRegister = (event) => {
    this.props.router.push(`signup?type=${event}`);
  };

  fetchquerytypeData = async () => {
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = API_SERVER + "/user-feedback-form/index";
    // const apiUrl =
    //   "https://pgrkamadmin.triazinesoft.com/m_api/v1/index.php/user-feedback-form/index";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
      });

      const data = await response.json();

      if (data && data.data) {
        this.setState({ querydata: data?.data });

      } else {
        this.setState({ error: "No job titles found." });
      }
    } catch (error) {
      console.error("Error fetching job titles:", error);
      this.setState({ error: "Error fetching job titles from the API" });
    }
  };

  createDistoption = () => {
    let Mainprops = this.props;
    let Distoption = [];
    if (Mainprops.actionReducer.selectedDistricts.length > 0) {
      Mainprops.actionReducer.selectedDistricts.map(function (data) {
        if (data.state_name === "Punjab") {
          data.dist.map(function (distdata, distindex) {
            Distoption.push(
              <option key={distindex} value={distdata.id}>
                {distdata.name}
              </option>
            );
            return Distoption;
          });
        }
        return Distoption;
      });
    }
    return Distoption;
  };


  // submitSearch = async (e) => {
  //   if (e) {
  //     e.preventDefault();
  //   }



  //   const { formData } = this.state;
  //   let errors = {};
  //   let formIsValid = true;

  //   // Validate Full Name
  //   if (!formData.full_name) {
  //     formIsValid = false;
  //     errors.full_name = "Full name is required.";
  //   }

  //   // Validate Mobile Number (example format)
  //   const mobileRegex = /^[0-9]{10}$/;
  //   if (!formData.mobile || !mobileRegex.test(formData.mobile)) {
  //     formIsValid = false;
  //     errors.mobile = "Please enter a valid mobile number.";
  //   }

  //   // Validate Email ID
  //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   if (!formData.email_id || !emailRegex.test(formData.email_id)) {
  //     formIsValid = false;
  //     errors.email_id = "Please enter a valid email address.";
  //   }

  //   // Validate Query Type
  //   if (!formData.feedback_type) {
  //     formIsValid = false;
  //     errors.feedback_type = "Please select a query type.";
  //   }

  //   // Validate Message
  //   if (!formData.message && formData.feedback_type) {
  //     formIsValid = false;
  //     errors.message = `${this.state.querydata.filter((e) => e.code === this.state.formData.feedback_type)[0]?.name} message is required.`;
  //   }

  //   // Validate Rating
  //   if (formData.rating === 0 && formData.feedback_type === "CAT_TRAINING_SATISFACTION") {
  //     formIsValid = false;
  //     errors.rating = "Please Give rating.";
  //   }

  //   if (formData.feedback_type === "CAT_TRAINING_SATISFACTION") {

  //     if (!this.state.district_id) {
  //       errors.district = "Please Select District"
  //     }
  //     if (!this.state.constituency_id) {
  //       errors.constituency = "Please Select Constituencys"
  //     }
  //     if (!this.state.sector_id) {
  //       errors.sector = "Please Select Sector"
  //     }
  //     if (!this.state.course_id) {
  //       errors.course = "Please Select Course"
  //     }
  //   }



  //   // If validation fails, set the error state and return
  //   if (!formIsValid) {
  //     this.setState({ errors });
  //     return;
  //   }

  //   store.dispatch(set_Loader())
  //   // Clear errors if all validations pass
  //   this.setState({ errors: {} });

  //   // If form is valid, proceed with the API request
  //   const apiUrl = `${API_SERVER}/user-feedback-form/submit`;

  //   try {
  //     // Create FormData to handle the image file upload
  //     const formDataToSend = new FormData();
  //     formDataToSend.append("full_name", formData.full_name);
  //     formDataToSend.append("mobile", formData.mobile);
  //     formDataToSend.append("email_id", formData.email_id);
  //     formDataToSend.append("feedback_type", formData.feedback_type);
  //     formDataToSend.append("message", formData.message);


  //     if (formData.feedback_type === "CAT_TRAINING_SATISFACTION") {
  //       formDataToSend.append("rating", formData.rating);
  //       formDataToSend.append("district_id", this.state.district_id);
  //       formDataToSend.append("subdivision_id", this.state.constituency_id);
  //       formDataToSend.append("sector_id", this.state.sector_id);

  //       formDataToSend.append("course_id", this.state.course_id);
  //     }

  //     if (formData.feedback_type === "CAT_TECH_QUERY") {
  //       // Append the image file, if it exists
  //       if (formData.image_file) {
  //         formDataToSend.append("image_file", formData.image_file);
  //       }
  //     }



  //     // Send the request with FormData
  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       "Content-Type": "multipart/form-data",
  //       body: formDataToSend, // Use FormData as the body
  //     });

  //     const data = await response.json();
  //     store.dispatch(unset_Loader ())
  //     if (data.status === "success") {

  //       this.setState({
  //         formData: {
  //           full_name: "",
  //           mobile: "",
  //           email_id: "",
  //           feedback_type: "CAT_FEEDBACK",
  //           message: "",
  //           image_file: "", // Reset the image file field after submission
  //           otp:""
  //         },
  //         is_otp_verify: 0,
  //         loading: false,
  //         district_id:'',
  //         sector_id:'',
  //         constituency_id:'',
  //         course_id:''
  //       });

  //       NotificationManager.success(data.message, "", 3000);
  //     } else {
  //       NotificationManager.error(data.message || data.errors.feedback_type[0], "", 3000);
  //     }

  //   } catch (error) {

  //     this.setState({
  //       error: "Error fetching data from the API",
  //       loading: false,
  //     });
  //   }
  // };

  submitSearch = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const sanitizeInput = (value) => {
      if (typeof value !== "string") return value;
      return value.trim().replace(/</g, "&lt;").replace(/>/g, "&gt;");
    };

    let { formData } = this.state;

    // Sanitize all form fields
    formData = {
      ...formData,
      full_name: sanitizeInput(formData.full_name),
      mobile: sanitizeInput(formData.mobile),
      email_id: sanitizeInput(formData.email_id),
      message: sanitizeInput(formData.message),
    };

    let errors = {};
    let formIsValid = true;

    // Validate Full Name
    if (!formData.full_name) {
      formIsValid = false;
      errors.full_name = "Full name is required.";
    }

    // Validate Mobile Number
    const mobileRegex = /^[0-9]{10}$/;
    if (!formData.mobile || !mobileRegex.test(formData.mobile)) {
      formIsValid = false;
      errors.mobile = "Please enter a valid mobile number.";
    }

    // Validate Email ID
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!formData.email_id || !emailRegex.test(formData.email_id)) {
      formIsValid = false;
      errors.email_id = "Please enter a valid email address.";
    }

    // Validate Query Type
    if (!formData.feedback_type) {
      formIsValid = false;
      errors.feedback_type = "Please select a query type.";
    }

    // Validate Message
    if (!formData.message && formData.feedback_type) {
      const feedbackName = this.state.querydata.find(
        (e) => e.code === formData.feedback_type
      )?.name;
      formIsValid = false;
      errors.message = `${feedbackName} message is required.`;
    }

    // Validate Rating
    if (formData.rating === 0 && formData.feedback_type === "CAT_TRAINING_SATISFACTION") {
      formIsValid = false;
      errors.rating = "Please Give rating.";
    }

    // Additional required fields for training satisfaction
    if (formData.feedback_type === "CAT_TRAINING_SATISFACTION") {
      if (!this.state.district_id) {
        formIsValid = false;
        errors.district = "Please Select District";
      }
      if (!this.state.constituency_id) {
        formIsValid = false;
        errors.constituency = "Please Select Constituency";
      }
      if (!this.state.sector_id) {
        formIsValid = false;
        errors.sector = "Please Select Sector";
      }
      if (!this.state.course_id) {
        formIsValid = false;
        errors.course = "Please Select Course";
      }
    }

    // If validation fails, set the error state and return
    if (!formIsValid) {
      this.setState({ errors });
      return;
    }

    store.dispatch(set_Loader());

    // Clear previous errors
    this.setState({ errors: {} });

    const apiUrl = `${API_SERVER}/user-feedback-form/submit`;

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("full_name", formData.full_name);
      formDataToSend.append("mobile", formData.mobile);
      formDataToSend.append("email_id", formData.email_id);
      formDataToSend.append("feedback_type", formData.feedback_type);
      formDataToSend.append("message", formData.message);

      if (formData.feedback_type === "CAT_TRAINING_SATISFACTION") {
        formDataToSend.append("rating", formData.rating);
        formDataToSend.append("district_id", this.state.district_id);
        formDataToSend.append("subdivision_id", this.state.constituency_id);
        formDataToSend.append("sector_id", this.state.sector_id);
        formDataToSend.append("course_id", this.state.course_id);
      }

      if (formData.feedback_type === "CAT_TECH_QUERY" && formData.image_file) {
        formDataToSend.append("image_file", formData.image_file);
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formDataToSend, // Let browser handle Content-Type
      });

      const data = await response.json();
      store.dispatch(unset_Loader());

      if (data.status === "success") {
        this.setState({
          formData: {
            full_name: "",
            mobile: "",
            email_id: "",
            feedback_type: "CAT_FEEDBACK",
            message: "",
            image_file: "",
            otp: "",
          },
          is_otp_verify: 0,
          loading: false,
          district_id: '',
          sector_id: '',
          constituency_id: '',
          course_id: '',
        });

        NotificationManager.success(data.message, "", 3000);
      } else {
        NotificationManager.error(data.message || data.errors.feedback_type?.[0], "", 3000);
      }
    } catch (error) {
      this.setState({
        error: "Error fetching data from the API",
        loading: false,
      });
    }
  };

  verifyCaptcha = (e) => {
    if (e) {
      e.preventDefault();
    }
    let user_captcha = document.getElementById("user_captcha_input").value;
    let errors = {};
    if (validateCaptcha(user_captcha) == true) {
      // alert("Captcha Matched");
      // loadCaptchaEnginge(6);
      this.setState({ isCaptchaVerified: true })
      // document.getElementById("user_captcha_input").value = "";
      errors.captcha = "";
      this.setState({ errors });
    } else {
      errors.captcha = "Captcha Does Not Match";
      document.getElementById("user_captcha_input").value = "";
      this.setState({ errors });
    }
  }


  handleInputChange = (e, queryChange) => {
    e.preventDefault();
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));

    if (queryChange) {
      this.setState((prevState) => ({
        sector_id: '',
        course_id: '',
        constituency_id: '',
        district_id: '',
      }));
    }
    this.setState({ errors: {} });
  };

  // handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     // Handle the file (e.g., set it in state, send it to a server, etc.)
  //     this.setState((prevState) => ({
  //       formData: {
  //         ...prevState.formData,
  //         image_file: file,
  //       },
  //     }));
  //   }
  // };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Allowed file types: PDF, JPEG, PNG, GIF
      const allowedTypes = ['image/jpeg', 'image/png'];
      const maxSize = 2 * 1024 * 1024; // 2MB
      if (!allowedTypes.includes(file.type)) {
        // If the file type is not valid, reset the input and show an error message
        // alert('Please upload a valid file (PDF or image).');
        NotificationManager.error('Please upload a valid file (PDF or image).', "", 3000);
        event.target.value = '';  // Clear the file input
        return;
      }

      if (file.size > maxSize) {
        NotificationManager.error("File size exceeds 2MB. Please upload a smaller file.");
        event.target.value = '';
        return;
      }

      // If file type is valid, update the state
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          image_file: file,
        },
      }));
    }
  };

  ratingChanged = (val) => {
    const formData = this.state.formData
    formData['rating'] = val
    this.setState({ formData })
  }

  sendOtp = async (e) => {
    const formData = this.state.formData;

    let errors = {};
    let formIsValid = true;
    // Validate Mobile Number (example format)
    const mobileRegex = /^[0-9]{10}$/;
    if (!formData.mobile || !mobileRegex.test(formData.mobile)) {
      formIsValid = false;
      errors.mobile = "Please enter a valid mobile number.";
    }

    if (!formIsValid) {
      this.setState({ errors });
      return;
    }


    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        ["mobile"]: "",
      },
    }));
    store.dispatch(set_Loader());
    // store.dispatch(sendOtp({ mobile: this.state.formData.mobile, email_id: this.state.formData.email_id }))

    try {
      const response = await fetch(`${API_SERVER}user-feedback-form/send-otp`, {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ mobile: this.state.formData.mobile, email_id: this.state.formData.email_id })
      });
      const data = await response.json();
      store.dispatch(unset_Loader())
      if (data.status === "success") {
        this.setState({ is_otp_verify: 1 });
        NotificationManager.success(data.message, "", 3000);
      } else {
        this.setState({ is_otp_verify: 0 });
        NotificationManager.error(data.message, "", 3000);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }


  }

  verifyOtp = async (e) => {
    store.dispatch(set_Loader());
    try {
      const response = await fetch(`${API_SERVER}user-feedback-form/submit-otp`, {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ mobile: this.state.formData.mobile, otp: this.state.formData.otp })
      });
      const data = await response.json();
      store.dispatch(unset_Loader());
      if (data.status === "success") {
        this.setState({ is_otp_verify: 2 });
        NotificationManager.success(data.message, "", 3000);
      } else {
        // this.setState({ is_otp_verify: 0 });
        NotificationManager.error(data.message, "", 3000);
      }
    } catch (error) {
      NotificationManager.error(data.message, "", 3000);
      console.error("Error fetching data:", error);
    }
  }

  // Helper function to get translated feedback type name
  getTranslatedFeedbackType = (code, fallbackName) => {
    if (!code) return fallbackName || '';
    
    // Try with the code as-is first
    let translationKey = `feedback_technical.${code}`;
    let translated = this.props.t(translationKey, { param: "react" });
    
    // If translation key doesn't exist, try without CAT_ prefix
    if (translated === translationKey && code.startsWith('CAT_')) {
      const codeWithoutPrefix = code.replace('CAT_', '');
      translationKey = `feedback_technical.${codeWithoutPrefix}`;
      translated = this.props.t(translationKey, { param: "react" });
    }
    
    // If still no translation found, use fallback
    if (translated === translationKey) {
      return fallbackName || code;
    }
    return translated;
  };

  handleUserInput(e) {
    const name = e.target.name;
    let value = e.target.value;
    let type = e.target.type;
    let key = e.target.key;

    if (type === "text") {
      let regex = /^[A-Za-z0-9 ]+$/;
      if (!regex.test(value) && value) {
        return false;
      }
    }

    if (this.state.error && e.target.name === "gender") {
      this.setState({ error: "" });
    }
    if (name === "education_level") {
      this.setState({ educid: value });
      // this.setState({educkey:key});
    }

    if (name === "remember") {
      let rememberCheckboxes = this.state.rememberCheckboxes;
      if (rememberCheckboxes.has(value)) {
        rememberCheckboxes.delete(value);
      } else {
        rememberCheckboxes.add(value);
      }
      this.setState({ rememberCheckboxes }, () => {
        value = Array.from(this.state.rememberCheckboxes);
      });
    }

    if (name === "subtype_id") {
      let selectedCheckboxes = this.state.selectedCheckboxes;
      if (selectedCheckboxes.has(value)) {
        selectedCheckboxes.delete(value);
      } else {
        selectedCheckboxes.add(value);
      }
      this.setState({ selectedCheckboxes }, () => {
        value = Array.from(this.state.selectedCheckboxes);
      });
    }
    if (name === "share_mobile") {
      let shareMobile = this.state.shareMobile;
      if (shareMobile.has(value)) {
        shareMobile.delete(value);
      } else {
        shareMobile.add(value);
      }
      this.setState({ shareMobile }, () => {
        value = Array.from(this.state.shareMobile);
      });
    }
    if (name === "sector_id") {
      store.dispatch(getCourses({ sector_id: value }))
    }
    this.setState({ [name]: value, submitStatus: false });
  }


  render() {
    const { validator } = this.props;
    if (
      this.props.actionReducer.link &&
      this.props.actionReducer.Loginuser &&
      this.props.actionReducer.Loginuser.user_type === "1"
    ) {
      window.location.href =
        this.state.basePath + this.props.actionReducer.link;
      return;
    }
    // if (
    //   localStorage.getItem("Islogin") &&
    //   localStorage.getItem("Islogin") !== "false"
    // ) {
    //   this.props.router.push("/myaccount");
    // }

    let Mainprops = this.props;



    let constituency = [];

    if (this.state.district_id) {
      constituency = this.props.actionReducer.constituency.filter(
        (data) => data.district_id === this.state.district_id
      );
    }
    return (
      <section className="login-form main-content-height">
        <div className="container mt-5">
          <div className="row m-0">
            <div className="col-md-8 mx-auto cover mb-4 cover-shadow border-0 ">
              <div className={"row"}>
                {/* <div className="col-md-6 first-click-inst p-4 ">
                  <h5>{this.props.t('register_user.instructions', { param: 'react' })}.</h5>
                  <ul className="jobseeker-benefits">
                    <li>{this.props.t('register_user.inst1', { param: 'react' })}</li>
                    <li>{this.props.t('register_user.inst2', { param: 'react' })}</li>
                    <li>{this.props.t('register_user.inst3', { param: 'react' })}</li>
                    <li>{this.props.t('register_user.inst4', { param: 'react' })}</li>
                    <li>{this.props.t('register_user.inst5', { param: 'react' })}</li>
                    <li>{this.props.t('register_user.inst6', { param: 'react' })}</li>
                    <li>{this.props.t('register_user.inst7', { param: 'react' })}</li>
                  </ul>
                  <span className={"me-2"}>{this.props.t('banner.already_registered', { param: 'react' })}</span>
                  <Link to={"signin"} className={"me-2"}>{this.props.t('banner.login', { param: 'react' })}</Link>


                </div> */}

                <div
                  className={"col-md-12 px-0"}
                // style={{ border: "1px solid #f7900d" }}
                >
                  <h2 className="p-3 formTitle mb-0">{this.props.t("feedback_technical.heading", {
                    param: "react",
                  })}</h2>
                  {/* {this.state.querydata.filter((e) => e.code === this.state.formData.feedback_type)[0]?.name} */}
                  <form className={"p-3"} onSubmit={this.submitSearch} aria-label="Service Request Form">
                    <div className="mb-3">
                      <label htmlFor="fullname" className="form-label">
                        {this.props.t('feedback_technical.f_name', { param: 'react' })}<span className="errorclr">*</span>
                      </label>
                      <input
                        autoComplete="fullname"
                        type="text"
                        className="form-control"
                        id="fullname"
                        name="full_name"
                        placeholder={this.props.t('feedback_technical.enterFname', { param: 'react' })}
                        required
                        aria-required="true"
                        aria-label="Full Name"
                        aria-invalid={!!this.state.errors.full_name}
                        aria-describedby={this.state.errors.full_name ? "fullNameError" : "fullnameHelp"}
                        value={this.state.formData.full_name}
                        onChange={this.handleInputChange}
                      />

                      <div id="fullnameHelp" className="form-text" role="alert" aria-live="assertive">
                        {this.props.t('feedback_technical.enterFnameErr', { param: 'react' })}
                      </div>

                      {this.state.errors.full_name && (
                        <div id="fullNameError" className="text-danger redcolrs" role="alert" aria-live="assertive">
                          {this.state.errors.full_name}
                        </div>
                      )}
                    </div>


                    <div className="mb-3">
                      <label htmlFor="Mobile Number" for="formGroupExampleInput" className="form-label">
                        {this.props.t('feedback_technical.mobile_no', { param: 'react' })}<span className="errorclr">*</span>
                      </label>
                      <input
                        aria-required="true"
                        type="tel"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder={this.props.t('feedback_technical.mobile_no', { param: 'react' })}
                        aria-label="Enter Mobile Number"
                        name="mobile"
                        value={this.state.formData.mobile}
                        onChange={this.handleInputChange}
                        disabled={this.state.is_otp_verify === 1 || this.state.is_otp_verify === 2}
                      />
                      {this.state.errors.mobile && (
                        <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                          {this.state.errors.mobile}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">

                      <div className="">

                        {this.state.is_otp_verify === 1 ? <><div className="form-group">
                          <div className="row">
                            <div className="col-sm-12 position-relative">
                              <label htmlFor="Login code" >
                                {this.props.t("login.code", { param: "react" })}
                              </label>
                              <input
                                placeholder={this.props.t("forms.enterOtp", {
                                  param: "react",
                                })}
                                type="number"
                                className="form-control form-eye"
                                id="password-otp"
                                name="otp"
                                aria-label="Enter password OTP"
                                defaultValue={this.state.otp}
                                maxLength="6"
                                onChange={this.handleInputChange}
                                aria-required="true"
                                aria-describedby="customer_name_error"
                              />

                              {/* <span
                                // onClick={(e) => this.handleInputChange( e)}
                                className="fa fa-fw togglePassword fa-eye-slash"
                              ></span> */}


                              {/* <span
                                  style={{ cursor: "pointer" }}
                                  className="date-clr mt-4 float-left mr-3"
                                // onClick={this.resendOtp.bind(this)}
                                >
                                  {this.props.t("login.resend_otp", { param: "react" })}
                                </span> */}
                            </div>
                          </div>
                        </div>
                          <button
                            aria-label="Verify OTP"
                            type="button" className="btn btn-primary2 me-2" onClick={this.verifyOtp} disabled={this.state.formData.otp.length < 2} >Verify OTP</button>
                          <button
                            aria-label="Edit Number"
                            type="button" className="btn btn-primary2 " onClick={() => {
                              this.setState({ is_otp_verify: 0 });

                            }} >Edit Number</button></>
                          : this.state.is_otp_verify === 0 ? <>
                            <button
                              aria-label="Send OTP"
                              type="button" className="btn btn-primary2 me-2" onClick={this.sendOtp} disabled={this.state.formData.mobile.length <= 0}>{this.props.t("feedback_technical.send_otp", {
                                param: "react",
                              })}</button></> : <></>}
                      </div>
                    </div>




                    <div className="mb-3">
                      <label htmlFor="emailInput" className="form-label">
                        {this.props.t("feedback_technical.email", {
                          param: "react",
                        })}  <span className="errorclr">*</span>
                      </label>
                      <input
                        autoComplete="email"
                        type="email"
                        className="form-control"
                        id="emailInput"
                        name="email_id"
                        placeholder={this.props.t("feedback_technical.enterEmail", {
                          param: "react",
                        })}
                        required
                        aria-required="true"
                        aria-label="Email ID"
                        aria-invalid={!!this.state.errors.email_id}
                        aria-describedby={this.state.errors.email_id ? "emailError" : "emailHelp"}
                        value={this.state.formData.email_id}
                        onChange={this.handleInputChange}
                      />

                      <div id="emailHelp" className="form-text">
                        {this.props.t("feedback_technical.emailConcern", {
                          param: "react",
                        })}
                      </div>

                      {this.state.errors.email_id && (
                        <div id="emailError" className="text-danger redcolrs" role="alert" aria-live="assertive">
                          {this.state.errors.email_id}
                        </div>
                      )}
                    </div>


                    <div className="mb-3">
                      <label for="exampleInputEmail1" className="form-label">
                        {this.props.t("feedback_technical.query_type", {
                          param: "react",
                        })}
                      </label>

                      <select
                        name="feedback_type"
                        value={this.state.formData.feedback_type}
                        onChange={(e) => { this.handleInputChange(e, 'query_change') }}
                        className="form-select"
                        aria-label="Select Feedback Type"
                        aria-required="true"
                      >
                        <option value=""> {this.props.t("feedback_technical.select", {
                          param: "react",
                        })}</option>
                        {this.state.querydata.map((item, index) => (
                          <option key={index} value={item.code}>
                            {this.getTranslatedFeedbackType(item.code, item.name)}
                          </option>
                        ))}
                      </select>
                      {this.state.errors.feedback_type && (
                        <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                          {this.state.errors.feedback_type}
                        </div>
                      )}
                    </div>



                    {this?.state?.formData?.feedback_type ===
                      "CAT_TECH_QUERY" ? (
                      <>
                        <div className="mb-3">
                          <label
                            for="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            {this.props.t("feedback_technical.fileUpload", {
                              param: "react",
                            })}

                          </label>
                          <div className="form-file-co">
                            <input
                              type="file"
                              className="form-control"
                              id="exampleFormControlFile1"
                              name="image"
                              aria-label="Upload image file"
                              accept=".jpeg,.jpg,.png"
                              onChange={this.handleFileChange}
                            /></div>
                        </div>

                      </>
                    ) : (
                      <></>
                    )}

                    {this?.state?.formData?.feedback_type === "CAT_TRAINING_SATISFACTION" ?
                      <div className="mb-3">
                        <label
                          for="exampleFormControlTextarea1"
                          className="form-label"
                        >
                          {this.props.t("feedback_technical.rating", {
                            param: "react",
                          })}<span className="errorclr">*</span>
                        </label><br />
                        <StarRatings
                          rating={this.state.formData.rating}
                          numberOfStars={5}
                          name='rating'
                          starRatedColor="rgb(255, 215, 0)"
                          starHoverColor="rgb(255, 215, 0)"
                          changeRating={this.ratingChanged}
                        />
                        {this.state.errors.rating && (
                          <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                            {this.state.errors.rating}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-sm-12 text-left">
                            <label>
                              {this.props.t("register_user.district", { param: "react" })}
                              <span className="errorclr ml-2">*</span>
                            </label>
                            <select
                              className="form-control"
                              id="district_id"
                              onChange={(event) => this.handleUserInput(event)}
                              name="district_id"
                              aria-label="Select District"
                              aria-required="true"
                            >
                              <option value={""}>
                                {this.props.t("profileDetails.selectDistrict", {
                                  param: "react",
                                })}
                              </option>
                              {this.createDistoption()}
                            </select>
                            {this.state.errors.district && (
                              <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                                {this.state.errors.district}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-sm-12 text-left">
                            <label>
                              {this.props.t("register_user.constituency", {
                                param: "react",
                              })}
                              <span className="errorclr">*</span>
                            </label>
                            <select
                              className="form-control"
                              onChange={(event) => this.handleUserInput(event)}
                              name="constituency_id"
                              aria-label="Select Constituency"
                              aria-required="true"
                            >
                              <option value={""}>
                                {this.props.t("profileDetails.selectConstituency", {
                                  param: "react",
                                })}
                              </option>
                              {constituency.length > 0 &&
                                constituency.map(function (data, index) {
                                  return (
                                    <option key={index} value={data.id}>
                                      {data.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          {this.state.errors.constituency && (
                            <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                              {this.state.errors.constituency}
                            </div>
                          )}
                        </div>

                        <div className="row mt-3">
                          <div className="col-sm-12 text-left">
                            <label>
                              {this.props.t("feedback_technical.selectSector", {
                                param: "react",
                              })}
                              <span className="errorclr">*</span>
                            </label>
                            <select
                              className="form-control"
                              onChange={(event) => this.handleUserInput(event)}
                              name="sector_id"
                              aria-label="Select Sector"
                              aria-required="true"
                            >
                              <option valconstituencyue={""}>
                                {this.props.t("feedback_technical.selectSector", {
                                  param: "react",
                                })}
                              </option>

                              {this.props.actionReducer.sectorsList.length > 0 &&
                                this.props.actionReducer.sectorsList.map(function (data, index) {
                                  return (
                                    <option key={index} value={data.id}>
                                      {data.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          {this.state.errors.sector && (
                            <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                              {this.state.errors.sector}
                            </div>
                          )}
                        </div>

                        <div className="row mt-3">
                          <div className="col-sm-12 text-left">
                            <label>
                              {this.props.t("feedback_technical.selectCourse", {
                                param: "react",
                              })}
                              <span className="errorclr">*</span>
                            </label>
                            <select
                              className="form-control"
                              onChange={(event) => this.handleUserInput(event)}
                              name="course_id"
                              aria-label="Select Course"
                              aria-required="true"
                            >
                              <option valconstituencyue={""}>
                                {this.props.t("feedback_technical.select_crse", {
                                  param: "react",
                                })}
                              </option>

                              {this.props.actionReducer?.coursesList?.length > 0 &&
                                this.props.actionReducer.coursesList.map(function (data, index) {
                                  return (
                                    <option key={index} value={data.id}>
                                      {data.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          {this.state.errors.course && (
                            <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                              {this.state.errors.course}
                            </div>
                          )}
                        </div>


                      </div> : <></>}

                    <div className="mb-3 mt-3">
                      <label
                        for="exampleFormControlTextarea1"
                        className="form-label"
                      >
                        {this.state.formData.feedback_type ? (
                          this.getTranslatedFeedbackType(
                            this.state.formData.feedback_type,
                            this.state.querydata.find((e) => e.code === this.state.formData.feedback_type)?.name
                          )
                        ) : ''}  <span className="errorclr">*</span>
                      </label>
                      {this.state.formData.feedback_type ? <textarea
                        className="form-control textAreaHeight"
                        id="exampleFormControlTextarea1"
                        cols="8"
                        rows="8"
                        placeholder={`${this.props.t("feedback_technical.enter", { param: "react" })} ${this.getTranslatedFeedbackType(
                          this.state.formData.feedback_type,
                          this.state.querydata.find((e) => e.code === this.state.formData.feedback_type)?.name
                        )}`}
                        name="message"
                        value={this.state.formData.message}
                        onChange={this.handleInputChange}

                      /> : <></>}


                      {this.state.errors.message && (
                        <div className="text-danger redcolrs" role="alert" aria-live="assertive">
                          {this.state.errors.message}
                        </div>
                      )}
                    </div>
                    {/* <div className="d-flex align-item-center my-3" >
                      <LoadCanvasTemplateNoReload />

                      <div className="">
                        <div className="mx-2">
                          <input
                            placeholder="Enter Captcha"
                            id="user_captcha_input"
                            name="user_captcha_input"
                            type="text"
                            className="p-2 rounded"
                            disabled={this.state.isCaptchaVerified}
                          ></input>
                        </div>

                        {this.state.errors.captcha && (
                          <div className="text-danger redcolrs">
                            {this.state.errors.captcha}
                          </div>
                        )}
                      </div>

                      <button type="button" disabled={this.state.isCaptchaVerified} onClick={() => this.verifyCaptcha()} aria-label="Submit to verify captcha" className="btn btn-primary btn-primary2">
                        {this.state.isCaptchaVerified ? "Captcha Verified" : "verify captcha"}
                      </button>

                    </div> */}
                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-primary2"
                        // disabled={this.state.is_otp_verify !== 2 || !this.state.isCaptchaVerified ? true : false}
                        disabled={this.state.is_otp_verify !== 2}
                        aria-label="Submit the Service Request Form"
                      >
                        {this.props.t("feedback_technical.submit", {
                          param: "react",
                        })}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NotificationContainer />
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  return store;
};

export default connect(mapStateToProps)(translate(Validation(feedbackForm)));